export default "__VITE_ASSET__CwNx1qxJ__"